<template>
  <template v-if="dataInfoArray">
    <div class="tw-flex tw-gap-3">
      <!-- Delete sections -->
      <template v-for="(data, index) in dataInfoArray" :key="index">
        <template v-if="data.type !== 'media'">
          <div class="tw-flex tw-flex-col tw-gap-2">
            <p class="tw-m-0 tw-text-lg tw-text-red-500">
              This action is permanent. You won't be able to recover this data
              once deleted.
            </p>
            <div class="tw-flex tw-gap-2">
              <TheButton variant="critical" size="large" @click="confirm()">
                <template #text>Delete</template>
              </TheButton>
              <TheButton variant="tertiary" size="large" @click="cancel()">
                <template #text>Cancel</template>
              </TheButton>
            </div>
          </div>
          <div
            class="tw-w-full tw-bg-gray-50 tw-border-solid tw-border tw-rounded-lg"
          >
            <ul class="tw-list-none tw-h-full tw-p-4 tw-m-0">
              <!-- <template v-if="data.data.length === 1"> -->
                <!-- <li v-for="item in data.data" :key="item.id" class="tw-h-full">
                  <template v-if="data.type === 'campaigns'">
                    <p class="tw-m-0 tw-text-lg tw-font-bold">Recipient</p>
                    <template v-if="item?.recipients[0]">
                      <p class="tw-text-lg tw-m-0">
                        {{
                          item?.recipients[0]?.firstName +
                          " " +
                          item?.recipients[0]?.lastName
                        }}
                      </p>
                      <p class="tw-text-lg tw-truncate">
                        {{ item?.recipients[0]?.contact?.email }}
                      </p>
                    </template>
                    <template v-else>
                      <p class="tw-text-lg tw-truncate">N/A</p>
                    </template>
                    <p class="tw-m-0 tw-text-lg tw-font-bold">Status</p>
                    <template v-if="item?.metadata?.campaign_status">
                      <p class="tw-text-lg tw-m-0 tw-capitalize">
                        {{ item?.metadata?.campaign_status }}
                      </p>
                    </template>
                    <template v-else>
                      <p class="tw-text-lg tw-truncate">N/A</p>
                    </template>
                  </template>
                  <template v-if="data.type === 'vendors'">
                    {{ item.name }}
                  </template>
                  <template v-if="data.type === 'recipients'">
                    <p class="tw-m-0 tw-text-lg tw-font-bold">Name</p>
                    <template v-if="item?.firstName && item?.lastName">
                      <p class="tw-text-lg">
                        {{ item.firstName + " " + item.lastName }}
                      </p>
                    </template>
                    <template v-else>N/A</template>
                    <p class="tw-m-0 tw-text-lg tw-font-bold">Email</p>
                    <template v-if="item?.contact?.email">
                      <p class="tw-text-lg">{{ item.contact.email }}</p>
                    </template>
                    <template v-else>N/A</template>
                  </template>
                  <template v-if="data.type === 'members'">
                    <div class="d-flex flex-column">
                      <span class="fw-bold"
                        >{{ item.firstName + " " + item.lastName }}
                      </span>
                      <span>{{ item.email }} </span>
                    </div>
                  </template>
                </li> -->
              <!-- </template> -->
              <!-- <template v-else> -->
                <li class="tw-h-full">
                  <div
                    class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-h-full"
                  >
                    <p class="tw-text-3xl tw-m-0 tw-font-bold">
                      {{ data.data.length }}
                    </p>
                    <p class="tw-text-xl tw-m-0">
                      {{ data.type }} will be deleted
                    </p>
                  </div>
                </li>
              <!-- </template> -->
            </ul>
          </div>
        </template>
      </template>
    </div>
  </template>
</template>

<script>
import TheButton from "../actions/TheButton.vue";
import TheCard from "../layout/TheCard.vue";
import CardHeader from "../layout/CardHeader.vue";
import TheBox from "../layout/TheBox.vue";

export default {
  name: "ConfirmDeleteModal",
  components: {
    TheButton,
    TheCard,
    CardHeader,
    TheBox,
  },
  props: {
    orders: {
      type: Array,
      required: false,
    },
    products: {
      type: Array,
      required: false,
    },
    kits: {
      type: Array,
      required: false,
    },
    proposals: {
      type: Array,
      required: false,
    },
    vendors: {
      type: Array,
      required: false,
    },
    shippingMethods: {
      type: Array,
      required: false,
    },
    packagingOptions: {
      type: Array,
      required: false,
    },
    members: {
      type: Array,
      required: false,
    },
    campaigns: {
      type: Array,
      required: false,
    },
    recipients: {
      type: Array,
      required: false,
    },
    media: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      dataTypes: {
        campaigns: this.campaigns,
        vendors: this.vendors,
        members: this.members,
        recipients: this.recipients,
        media: this.media,
      },
    };
  },
  computed: {
    dataInfoArray() {
      const dataTypes = [
        { type: "campaigns", data: this.campaigns },
        { type: "vendors", data: this.vendors },
        { type: "members", data: this.members },
        { type: "recipients", data: this.recipients },
        { type: "media", data: this.media },
      ];

      return dataTypes.filter((dataInfo) => dataInfo.data);
    },
  },
  methods: {
    confirm() {
      this.$emit("confirmDelete");
    },
    cancel() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped></style>
